import * as tslib_1 from "tslib";
// Core packages
import { formatNumber } from "@angular/common";
import { AfterViewInit, ElementRef, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { MatDialog, MatPaginator, MatSort } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { forkJoin, of, throwError } from "rxjs";
import { catchError, distinctUntilChanged, finalize, map, startWith, take } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { BalancesService } from "src/app/modules/balances/balances.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { DeadlinesService } from "src/app/modules/deadlines/deadlines.service";
import { PricesService } from "src/app/modules/prices/prices.service";
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import { DocumentArchiveDocsService } from "src/app/modules/properties/document-archive-docs.service";
import { treeHasLeaseContract } from "src/app/modules/properties/document-archive-privacy-sag.utils";
import DocumentTypeStructure from "src/app/modules/properties/documentTypes";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { StatementsService } from "src/app/modules/properties/statements.service";
import { SubscriptionsService } from "src/app/modules/subscriptions/subscriptions.service";
import { SuppliersService } from "src/app/modules/suppliers/suppliers.service";
import { UsersService } from "src/app/modules/users/users.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { Company } from "src/app/shared/models/company/company.model";
import { Property } from "src/app/shared/models/property/property.model";
import { User } from "src/app/shared/models/user/user.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ListsService } from "src/app/shared/services/lists.service";
import { ThemeService } from "src/app/shared/services/theme.service";
import { BalancesDataSource } from "src/app/shared/utils/data-sources/balances-data-source";
import { DeadlinesDataSource } from "src/app/shared/utils/data-sources/deadlines-data-source";
import { PhonebookDataSource } from "src/app/shared/utils/data-sources/phonebook-data-source";
import { StatementsDataSource } from "src/app/shared/utils/data-sources/statements-data-source";
import { isArchiveV3Live } from "src/app/shared/utils/archive-switch.utils";
import { PlatformNotesService } from "src/app/components/platform-note-card/platformNotes.service";
import { CompanyPlatformNotesDialogComponent } from 'src/app/modules/properties/components/company-platfom-notes-dialog/company-platform-notes-dialog.component';
import { AdminCompanyPrivacySagDialogComponent } from 'src/app/modules/properties/components/admin-company-privacy-sag-dialog/admin-company-privacy-sag-dialog.component';
var PropertyDetail2Component = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyDetail2Component(dialog, newMessageDialog, cancelContractDialog, configService, activatedRoute, propertiesService, router, toastrService, helperService, translateService, themeService, authService, cookieService, companiesService, apiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    subscriptionsService, pricesService, balancesService, listsService, userService, deadlinesService, suppliersService, documentArchivesService, condoStructuresService, statementsService, platformNotesService, documentArchiveDocsService) {
        this.dialog = dialog;
        this.newMessageDialog = newMessageDialog;
        this.cancelContractDialog = cancelContractDialog;
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.propertiesService = propertiesService;
        this.router = router;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.companiesService = companiesService;
        this.apiService = apiService;
        this.subscriptionsService = subscriptionsService;
        this.pricesService = pricesService;
        this.balancesService = balancesService;
        this.listsService = listsService;
        this.userService = userService;
        this.deadlinesService = deadlinesService;
        this.suppliersService = suppliersService;
        this.documentArchivesService = documentArchivesService;
        this.condoStructuresService = condoStructuresService;
        this.statementsService = statementsService;
        this.platformNotesService = platformNotesService;
        this.documentArchiveDocsService = documentArchiveDocsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // Could not be "Property" type because in "get" method in the back-end
        // We are populating some fields, so the model is not the same!
        this.property = new Property();
        this.propertyId = "";
        this.companyId = "";
        this.loggedUserShared = false;
        this.loggedUserMaster = false;
        this.loggedUserAdmin = false;
        this.detailCardIsLoading = true;
        this.deleteCardIsLoading = true;
        this.sharedUserCardIsLoading = true;
        this.phonebookCardIsLoading = true;
        this.loggedUserRoleType = "";
        this.masterOnlySuppliersAndNfcTag = false;
        this.masterOnlySuppliers = false;
        this.masterOnlyNfcTag = false;
        this.subscriptionDocumentUpload = false;
        // BEGIN - Admin company Privacy SAG dialog (see maybeShowAdminCompanyPrivacySagDialog)
        this.adminCompanyChangedOnSubmit = false;
        /** At the 3.0.0 switch the lease contracts are read from the new archive tree */
        this.archiveV3Live = isArchiveV3Live();
        // END - Admin company Privacy SAG dialog
        // BEGIN - Edit property form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.formSC = new FormGroup({});
        this.formSP = new FormGroup({});
        this.model = {};
        this.modelSC = {};
        this.modelSP = {};
        this.anagraphicFields = [];
        this.contractFields = [];
        this.statusFields = [];
        this.options = {};
        this.formSharedUser = new FormGroup({});
        this.modelSharedUser = {};
        this.sharedUserFields = [];
        this.optionsSharedUser = {};
        // "Cambio Amministratore" (incoming administrator / handover) field: kept in a
        // dedicated Formly form so it stays decoupled from the anagraphic form. Its
        // value is copied into the property payload as the `incomingAdmin` company id
        // only on the anagraphic submit (see onFormSubmit / initChangeAdminField).
        this.formChangeAdmin = new FormGroup({});
        this.modelChangeAdmin = {};
        this.changeAdminFields = [];
        this.optionsChangeAdmin = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        this.formSharedUserBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        this.deleteBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.deactivate"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "warn",
            spinnerColor: "warn",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-times",
                inline: true,
            },
        };
        this.reactivateBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.activate"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-check",
                inline: true,
            },
        };
        // END - Edit property form
        // BEGIN - Table balances
        this.balancesDisplayedColumns = [
            "index",
            "number",
            "status",
            "total",
            "discount",
            "createdAt",
            "actions",
        ];
        this.numberFilter = new FormControl("");
        this.statusFilter = new FormControl("");
        this.totalFilter = new FormControl("");
        this.discountFilter = new FormControl("");
        this.createdAtFilter = new FormControl("");
        this.balancesCardIsLoading = true;
        // END - Table balances
        // BEGIN - Table deadlines
        this.deadlinesDisplayedColumns = [
            "index",
            "structureObjectName",
            "document",
            "memoTime",
            "renewalType",
            "endDate",
            "actions",
        ];
        // areaFilter: FormControl = new FormControl("");
        this.structureObjectNameFilter = new FormControl('');
        this.documentFilter = new FormControl("");
        this.endDateFilter = new FormControl(moment().startOf("day"));
        this.memoTimeFilter = new FormControl("");
        this.renewalTypeFilter = new FormControl("");
        // END - Table deadlines
        // BEGIN - phonebook table properties
        this.phonebookDisplayedColumns = [
            "index",
            "firstName",
            "lastName",
            "email",
            "createdAt",
            "actions",
        ];
        // END - phonebook table properties
        // BEGIN - Table balances
        this.statementsDisplayedColumns = [
            "index",
            "startDate",
            "endDate",
            "file",
            "actions",
        ];
        // @ViewChild("statementsInput", { static: false }) statementsInput: ElementRef;
        // numberStatementFilter: FormControl = new FormControl("");
        this.startDateStatementFilter = new FormControl("");
        this.endDateStatementFilter = new FormControl("");
        this.statementsCardIsLoading = true;
        // END - Table statements
        this.prices = [];
        this.isInit = true;
        this.enableEdit = false;
        this.sharedUser = new User();
        this.previousPermissions = {
            unlimited: false,
            mappatura: false,
            gestionaleAmministrativo: false,
            amminImmobile: false,
            gestionaleContabile: false,
            urbanisticaEdEdilizia: false,
            catasto: false,
            contratti: false,
            lineaVita: false,
            amiantoDoc: false,
            edile: false,
            impiantoElettrico: false,
            riscaldamentoCondizionamento: false,
            ascensoriEMontauto: false,
            trattamentoAcqua: false,
            impiantiElettronici: false,
            antincendio: false,
            impiantiSpeciali: false,
            impiantiRicreativiSportivi: false,
            unitaImmobiliari: false,
            preventivi: false,
        };
        this.deadlinesCardIsLoading = true;
        this.documentTypeStructure = new DocumentTypeStructure();
        this.subscriptionType = "FREE";
        this.previousSafetyContract = {};
        this.previousAntifireContract = {};
        this.previousSubscription = {};
        this.availableTypes = [];
        this.archediSubscriptions = [];
        // List of codes
        this.firstScanCodes = this.configService.availableScanCodes;
        this.firstFixedPackCodes = this.configService.availableFixedPackageCodes;
        this.scanInsNextCodesForfait = this.configService.availableInsCodesNextForfait;
        this.scanNextCodesForfait = this.configService.availableScanCodesNextForfait;
        this.previousTotalStorageSpaceUsed = 0;
        // Dati aggiuntivi elenco/nuovo elemento
        this.suppliersName = [];
        this.yearsOfStorage = [];
        this.conductorName = [];
        this.nameInterventionArchiving = [];
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.companyName = "";
        this.companyData = {};
        this.company = new Company();
        this.mappaturaOpen = false;
        // Status card
        this.sagDate = new FormControl("");
        this.statusCardIsLoading = true;
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.ngOnInit = function () {
        var _this = this;
        this.propertyId = this.activatedRoute.snapshot.params.propertyId;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("properties.detail.pageTitle"));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
            var currentRole = _this.loggedUser.userRoles.find(function (obj) {
                return (obj._id.toString() ===
                    _this.authService.loggedUserRequestedRole$.getValue().toString());
            });
            _this.loggedUserRoleType = currentRole.role.type;
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        // Init data sources
        this.balancesDataSource = new BalancesDataSource(this.balancesService, this.helperService);
        this.phonebookDataSource = new PhonebookDataSource(undefined, this.helperService, this.propertiesService);
        this.deadlinesDataSource = new DeadlinesDataSource(this.deadlinesService, this.helperService, this.translateService);
        this.statementsDataSource = new StatementsDataSource(this.statementsService, this.helperService);
        // Init areas
        this.availableTypes = this.configService.availableDocumentAreas.map(function (element) {
            return {
                value: element,
                label: _this.translateService.instant("properties.documents.areas." + element),
            };
        });
        // Se default start and end date
        this.defaultStartDate = moment().format("YYYY-MM-DD"); // .toISOString();
        this.defaultEndDate = moment()
            .add(1, "years")
            .subtract(1, "days")
            .format("YYYY-MM-DD"); // .toISOString();
        this.getPrices();
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Get logged user's role data
        this.currentRole = this.loggedUser.userRoles.find(function (obj) {
            return (obj._id.toString() ===
                _this.authService.loggedUserRequestedRole$.getValue().toString());
        });
        if (this.currentRole.role.type === "shared") {
            this.loggedUserShared = true;
        }
        if (this.currentRole.role.type === "master" ||
            this.currentRole.role.type === "collaborator") {
            this.loggedUserMaster = true;
            if (this.currentRole.company._id !== "") {
                this.subscriptions.push(this.companiesService
                    .get(this.currentRole.company._id)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.companyData = res.data;
                        _this.company.setData(res.data);
                        if (!res.data.subscription.documentUpload &&
                            res.data.subscription.nfcAccess &&
                            res.data.subscription.suppliers) {
                            _this.masterOnlySuppliersAndNfcTag = true;
                        }
                        else if (!res.data.subscription.documentUpload &&
                            !res.data.subscription.nfcAccess &&
                            res.data.subscription.suppliers) {
                            _this.masterOnlySuppliers = true;
                        }
                        else if (!res.data.subscription.documentUpload &&
                            res.data.subscription.nfcAccess &&
                            !res.data.subscription.suppliers) {
                            _this.masterOnlyNfcTag = true;
                        }
                    }
                }));
            }
        }
        if (this.currentRole.role.type === "admin" ||
            this.currentRole.role.type === "operator") {
            this.loggedUserAdmin = true;
        }
        // Get requested property data
        this.subscriptions.push(this.propertiesService
            .get(this.activatedRoute.snapshot.params.propertyId)
            .subscribe(function (res) {
            if (res.status) {
                // Set permission data
                _this.property.setData(res.data);
                _this.propertyData = res.data;
                _this.companyId = _this.property.get("admin.company._id");
                if (typeof _this.companyId === "undefined") {
                    _this.companyId = _this.property.get("admin.company");
                }
                for (var prop in res.data.subscription) {
                    _this.previousSubscription[prop] =
                        res.data.subscription[prop];
                }
                if (_this.propertyData.subscription &&
                    _this.propertyData.subscription.key) {
                    _this.subscriptionType = _this.propertyData.subscription.key;
                    if (_this.propertyData.subscription.documentUpload) {
                        _this.subscriptionDocumentUpload = true;
                    }
                }
                if (_this.propertyData.structure) {
                    _this.subscriptions.push(_this.condoStructuresService.get(_this.propertyData.structure)
                        .subscribe(function (res) {
                        if (res.status &&
                            res.data) {
                            _this.mappaturaOpen = res.data.open;
                        }
                    }, function (err) {
                        _this.helperService.handleError(err);
                    }));
                }
                // Stop loading in delete form
                _this.deleteCardIsLoading = false;
                // Get form initial values and init the form
                _this.getDataAndInitForm();
                return;
            }
            // Something bad happened
            // redirect user to home
            _this.router.navigate([_this.lang, "app", "properties", "list"]);
        }, function (err) {
            // if we came here users with given userId do not exist
            _this.router.navigate([_this.lang, "errors", "404"]);
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        if (this.balancesPaginator) {
            // Push current list settings to the listsService
            this.listsService.setListSetting("balances", this.balancesPaginator.pageIndex.valueOf(), this.balancesPaginator.pageSize.valueOf(), {
                general: this.balancesInput.nativeElement.value,
                number: this.numberFilter.value,
                status: this.statusFilter.value,
                total: this.totalFilter.value,
                discount: this.discountFilter.value,
                createdAt: this.createdAtFilter.value,
            });
        }
        if (this.deadlinesPaginator) {
            // Push current list settings to the listsService
            this.listsService.setListSetting("deadlines", this.deadlinesPaginator.pageIndex.valueOf(), this.deadlinesPaginator.pageSize.valueOf(), {
                structureObjectName: this.structureObjectNameFilter.value,
                documentFilter: this.documentFilter.value,
                endDateFilter: this.endDateFilter.value,
                memoTimeFilter: this.memoTimeFilter.value,
                renewalTypeFilter: this.renewalTypeFilter.value,
            });
        }
    };
    /**
     * Get prices from backend
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.getPrices = function () {
        var _this = this;
        this.subscriptions.push(this.pricesService.getList(0, 15).subscribe(function (res) {
            var _a;
            if (res.status) {
                (_a = _this.prices).push.apply(_a, tslib_1.__spread(res.data.items));
                _this.getSubscriptions();
            }
        }));
    };
    /**
     * Load requested subscription data
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.getSubscriptions = function () {
        var _this = this;
        this.subscriptionsService.getList().subscribe(function (res) {
            if (res.status) {
                _this.archediSubscriptions = res.data.items;
                var subscriptions = res.data.items.map(function (item) {
                    return {
                        value: item,
                        label: item.name,
                    };
                });
                _this.availableSubscriptions = subscriptions.filter(function (element) {
                    return element.value.key !== "QRANTINCENDIO";
                });
                _this.availableSubscriptionsKeys = _this.availableSubscriptions.map(function (element) {
                    return {
                        value: element.value.key,
                        label: element.value.name,
                    };
                });
                // Create an empty value
                var noSubscription = {
                    value: "noSubscription",
                    label: _this.translateService.instant("subscriptions.fields.noSubscription"),
                };
                _this.availableSubscriptionsKeys.push(noSubscription);
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Get requested initialValues for the form and than init it
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.getDataAndInitForm = function () {
        var _this = this;
        // Build the "Cambio Amministratore" handover field only for admin/operator
        // users (loggedUserAdmin); it is hidden for everyone else. Decoupled from
        // the anagraphic form; resolves an in-progress handover for display.
        if (this.loggedUserAdmin) {
            this.initChangeAdminField();
        }
        var adminCompanyId = this.property.get("admin.company._id") || this.property.get("admin.company");
        if (this.property.get("owner._id")) {
            var requests = adminCompanyId
                ? [this.companiesService.get(adminCompanyId), this.companiesService.get(this.property.get("owner._id"))]
                : [this.companiesService.get(this.property.get("owner._id"))];
            this.subscriptions.push(forkJoin(requests).subscribe(function (res) {
                var initialAdminData;
                var initialOwnerData;
                if (adminCompanyId) {
                    if (res[0] && res[0].status) {
                        initialAdminData = [res[0].data];
                        _this.companyName = res[0].data.name;
                    }
                    if (res[1] && res[1].status) {
                        initialOwnerData = [res[1].data];
                    }
                }
                else {
                    if (res[0] && res[0].status) {
                        initialOwnerData = [res[0].data];
                    }
                }
                // Init edit form
                _this.initForm(initialAdminData, initialOwnerData);
                // Make detail form card visible by disabling his card-spinner
                _this.detailCardIsLoading = false;
            }));
        }
        else if (adminCompanyId) {
            this.companiesService
                .get(adminCompanyId)
                .subscribe(function (res) {
                var initialAdminData;
                if (res && res.status) {
                    initialAdminData = [res.data];
                    _this.companyName = res.data.name;
                }
                // Init edit form
                _this.initForm(initialAdminData);
                // Make detail form card visible by disabling his card-spinner
                _this.detailCardIsLoading = false;
            });
        }
        else {
            // No adminCompanyId and no owner — init form without company data
            this.initForm();
            this.detailCardIsLoading = false;
        }
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.initForm = function (initialAdminData, initialOwnerData) {
        var _this = this;
        if (initialAdminData && Array.isArray(initialAdminData) && initialAdminData.length) {
            if (initialAdminData[0].subscription) {
                Object.keys(initialAdminData[0].subscription).forEach(function (key) {
                    if (key === 'startDateSuppliers') {
                        _this.masterStarDateSupplier = initialAdminData[0].subscription[key];
                    }
                    if (key === 'endDateSuppliers') {
                        _this.masterEndDateSupplier = initialAdminData[0].subscription[key];
                    }
                    if (key === 'suppliersFee') {
                        _this.masterSuppliersFee = initialAdminData[0].subscription[key];
                    }
                });
            }
        }
        // Set model
        this.model = this.property.getData();
        this.modelSC = this.property.getData();
        if (this.modelSC.subscription.totalStorageSpaceUsed) {
            this.previousTotalStorageSpaceUsed =
                this.modelSC.subscription.totalStorageSpaceUsed;
            this.modelSC.subscription.totalStorageSpaceUsed = formatNumber(this.modelSC.subscription.totalStorageSpaceUsed, "it-IT");
        }
        if (this.propertyData.propertyStatus &&
            this.propertyData.propertyStatus.mappingCompleted &&
            this.propertyData.propertyStatus.mappingCompleted.user) {
            this.propertyData.propertyStatus.mappingCompleted.username =
                this.propertyData.propertyStatus.mappingCompleted.user.firstName + " " + this.propertyData.propertyStatus.mappingCompleted.user.lastName;
        }
        this.propertyData.propertyStatus.startDate.date = this.propertyData.subscription.startDate;
        this.modelSP.propertyStatus = this.propertyData.propertyStatus;
        // For price list sorting
        var index = 0;
        // Minimum char amount to activate search filtering
        var minTermLength = 1;
        // Set price
        if (this.modelSC.subscription.prices) {
            this.modelSC.subscription.prices.forEach(function (elem, index) {
                switch (index) {
                    case 0:
                        _this.modelSC.subscription.price1 = { discount: elem.discount };
                        break;
                    case 1:
                        _this.modelSC.subscription.price2 = { discount: elem.discount };
                        break;
                    case 2:
                        _this.modelSC.subscription.price3 = { discount: elem.discount };
                        break;
                    case 3:
                        _this.modelSC.subscription.price4 = { discount: elem.discount };
                        break;
                    case 4:
                        _this.modelSC.subscription.price5 = { discount: elem.discount };
                        break;
                    case 5:
                        _this.modelSC.subscription.price6 = { discount: elem.discount };
                        break;
                    case 6:
                        _this.modelSC.subscription.price7 = { discount: elem.discount };
                        break;
                    case 7:
                        _this.modelSC.subscription.price8 = { discount: elem.discount };
                        break;
                    case 8:
                        _this.modelSC.subscription.price9 = { discount: elem.discount };
                        break;
                    case 9:
                        _this.modelSC.subscription.price10 = { discount: elem.discount };
                        break;
                    case 10:
                        _this.modelSC.subscription.price11 = { discount: elem.discount };
                        break;
                }
            });
        }
        this.model.admin.company =
            this.model &&
                this.model.admin &&
                this.model.admin.company &&
                this.model.admin.company._id
                ? this.model.admin.company._id
                : undefined;
        this.model.owner =
            this.model && this.model.owner && this.model.owner._id
                ? this.model.owner._id
                : undefined;
        // Set fields
        this.anagraphicFields = [
            // ...this.anagraphicFields,
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12 col-md-6",
                        type: "autocomplete",
                        key: "admin.company",
                        templateOptions: {
                            customLabel: this.translateService.instant("properties.fields.admin"),
                            placeholder: this.translateService.instant("properties.fields.admin"),
                            required: true,
                            bindLabel: "name",
                            bindValue: "_id",
                            multiple: false,
                            search$: this.companiesService.getList.bind(this),
                            initialValues: initialAdminData,
                            hideSelected: true,
                            disabled: this.loggedUserMaster,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant("common.words.typeToSearch", { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant("common.words.clearAll"),
                            notFoundText: this.translateService.instant("common.words.notFound"),
                            loadingText: this.translateService.instant("common.words.loading"),
                            callback: function (data) {
                                _this.onAdminCompanySelected(data);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "autocomplete",
                        key: "owner",
                        templateOptions: {
                            customLabel: this.translateService.instant("properties.fields.owner"),
                            placeholder: this.translateService.instant("properties.fields.owner"),
                            required: false,
                            bindLabel: "name",
                            bindValue: "_id",
                            multiple: false,
                            search$: this.companiesService.getList.bind(this),
                            initialValues: initialOwnerData,
                            hideSelected: true,
                            // addTag: true,
                            disabled: this.loggedUserMaster,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant("common.words.typeToSearch", { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant("common.words.clearAll"),
                            notFoundText: this.translateService.instant("common.words.notFound"),
                            // addTagText: this.translateService.instant("common.words.addTag"),
                            loadingText: this.translateService.instant("common.words.loading"),
                        },
                    },
                    {
                        className: "col-12 col-md-4 col-xl-3",
                        type: "select",
                        key: "type",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.type"),
                            placeholder: this.translateService.instant("properties.fields.type"),
                            required: true,
                            disabled: this.loggedUserMaster,
                            options: [
                                {
                                    value: "co",
                                    label: this.translateService.instant("properties.types.co"),
                                },
                                {
                                    value: "bsc",
                                    label: this.translateService.instant("properties.types.bsc"),
                                },
                                {
                                    value: "pur",
                                    label: this.translateService.instant("properties.types.pur"),
                                },
                                {
                                    value: "puc",
                                    label: this.translateService.instant("properties.types.puc"),
                                },
                                {
                                    value: "sp",
                                    label: this.translateService.instant("properties.types.sp"),
                                },
                            ],
                        },
                    },
                    {
                        className: "col-12 col-md-4 col-xl-3",
                        type: "input",
                        key: "name",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.name"),
                            placeholder: this.translateService.instant("properties.fields.name"),
                            required: true,
                            disabled: this.loggedUserMaster,
                            minLength: 2,
                            maxLength: 100,
                        },
                    },
                    {
                        className: "col-12 col-md-4 col-xl-3",
                        type: "input",
                        key: "notifyMail1",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.notifyMail1"),
                            placeholder: this.translateService.instant("properties.fields.notifyMail1"),
                            required: true,
                            minLength: 5,
                            maxLength: 320,
                            type: "email",
                        },
                    },
                    {
                        className: "col-12 col-md-4 col-xl-3",
                        type: "input",
                        key: "notifyMail2",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.notifyMail2"),
                            placeholder: this.translateService.instant("properties.fields.notifyMail2"),
                            required: false,
                            minLength: 5,
                            maxLength: 320,
                            type: "email",
                        },
                    },
                    {
                        className: "col-12 col-md-4 col-xl-3",
                        type: "input",
                        key: "masterCode",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.masterCode"),
                            placeholder: this.translateService.instant("properties.fields.masterCode"),
                            required: false,
                            minLength: 0,
                            maxLength: 50,
                        },
                    },
                    {
                        className: "col-12 col-md-9",
                        type: "address",
                        key: "address",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.address"),
                            placeholder: this.translateService.instant("properties.fields.address"),
                            required: false,
                            disabled: this.loggedUserMaster,
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "input",
                        key: "taxCode",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.taxCode"),
                            placeholder: this.translateService.instant("properties.fields.taxCode"),
                            required: true,
                            disabled: this.loggedUserMaster,
                            minLength: 0,
                            maxLength: 20,
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "input",
                        key: "sdiCode",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.sdiCode"),
                            placeholder: this.translateService.instant("properties.fields.sdiCode"),
                            required: false,
                            disabled: this.loggedUserMaster,
                            minLength: 6,
                            maxLength: 7,
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "day-month-picker",
                        key: "administrationStartDate",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.administrationStartDate"),
                            placeholder: this.translateService.instant("properties.fields.administrationStartDate"),
                            minLength: 2,
                            maxLength: 100,
                        },
                        modelOptions: {
                            updateOn: "change",
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "day-month-picker",
                        key: "administrationEndDate",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.administrationEndDate"),
                            placeholder: this.translateService.instant("properties.fields.administrationEndDate"),
                            minLength: 2,
                            maxLength: 100,
                        },
                        modelOptions: {
                            updateOn: "change",
                        },
                    },
                    // {
                    //   className: "col-12 col-sm-6",
                    //   type: "input",
                    //   key: "iban",
                    //   templateOptions: {
                    //     label: this.translateService.instant("properties.fields.iban"),
                    //     placeholder: this.translateService.instant(
                    //       "properties.fields.iban"
                    //     ),
                    //     required: false,
                    //     minLength: 27,
                    //     maxLength: 27,
                    //   },
                    // },
                    {
                        className: "col-12 col-sm-3",
                        type: "checkbox",
                        key: "dossier",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.dossier"),
                            placeholder: this.translateService.instant("properties.fields.dossier"),
                            required: false,
                            disabled: this.loggedUserMaster,
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "input",
                        key: "dossierEmail",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.dossierEmail"),
                            placeholder: this.translateService.instant("properties.fields.dossierEmail"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return _this.loggedUserMaster || !_this.model.dossier;
                            },
                            "templateOptions.required": function () {
                                return _this.model.dossier;
                            },
                        },
                    },
                    {
                        className: "col-12 col-sm-6",
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "checkbox",
                        key: "newDocumentTree",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.newDocumentTree"),
                            placeholder: this.translateService.instant("properties.fields.newDocumentTree"),
                            required: false,
                            disabled: this.loggedUserMaster,
                        },
                    },
                ],
            },
        ];
        this.contractFields = [
            // 1. PLATFORM SUBSCRIPTION
            {
                fieldGroupClassName: "row",
                hooks: {
                    onInit: function () {
                        _this.updateSubscriptionCodes();
                    },
                },
                fieldGroup: [
                    {
                        className: "col-12 boxForm",
                        template: "<div><strong>" +
                            this.translateService.instant("companies.fields.subscription.subscription") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "checkbox",
                        key: "subscription.documentUpload",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.documentUpload.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.documentUpload.title"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "select",
                        key: "subscription.invoiceHolder",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.invoiceHolder.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.invoiceHolder.title"),
                            required: true,
                            multiple: false,
                            options: [
                                {
                                    value: "property",
                                    label: this.translateService.instant("companies.fields.subscription.invoiceHolder.property"),
                                },
                                {
                                    value: "admin",
                                    label: this.translateService.instant("companies.fields.subscription.invoiceHolder.admin"),
                                },
                                {
                                    value: "owner",
                                    label: this.translateService.instant("companies.fields.subscription.invoiceHolder.owner"),
                                },
                            ],
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit || !_this.modelSC.subscription.documentUpload;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-4",
                        type: "select",
                        key: "subscription.key",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.subscriptionType"),
                            placeholder: this.translateService.instant("companies.fields.subscription.subscriptionType"),
                            multiple: false,
                            options: this.availableSubscriptionsKeys,
                            required: true,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit || !_this.modelSC.subscription.documentUpload;
                            },
                        },
                    },
                    {
                        className: "col-4",
                        type: "input",
                        key: "subscription.fee",
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.fee"),
                            placeholder: this.translateService.instant("subscriptions.fields.fee"),
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 10000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription' && model.subscription.key !== 'PRIVACY'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" || _this.modelSC.subscription.key === "PRIVACY")));
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-4",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "input",
                        key: "subscription.availableSpace",
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.availableSpace"),
                            placeholder: this.translateService.instant("subscriptions.fields.availableSpace"),
                            type: "number",
                            min: 0,
                            max: 1000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription' && model.subscription.key !== 'PRIVACY'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" || _this.modelSC.subscription.key === "PRIVACY")));
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "input",
                        key: "subscription.totalStorageSpaceUsed",
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.totalStorageSpaceUsed"),
                            placeholder: this.translateService.instant("subscriptions.fields.totalStorageSpaceUsed"),
                            // type: "number",
                            // step: 0.001,
                            // min: 0,
                            // max: 50000,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-0 col-md-4",
                    },
                ],
            },
            // 2. STRUCTURE SUBSCRIPTION
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.structure.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.structure",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.structure.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.structure.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription' && model.subscription.key !== 'PRIVACY' && model.subscription.key !== 'FREE' && model.subscription.key !== 'FREEBASIC'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" || _this.modelSC.subscription.key === "PRIVACY" ||
                                            _this.modelSC.subscription.key === "FREE" ||
                                            _this.modelSC.subscription.key === "FREEBASIC")));
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.structurePrice",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.structurePrice"),
                            placeholder: this.translateService.instant("companies.fields.subscription.structurePrice"),
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 10000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.structure",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" || _this.modelSC.subscription.key === "PRIVACY" ||
                                            _this.modelSC.subscription.key === "FREE" ||
                                            _this.modelSC.subscription.key === "FREEBASIC" ||
                                            !_this.modelSC.subscription.structure)));
                            },
                        },
                    },
                ],
            },
            // 3. FIRST BALANCE
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.firstBalance.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.firstPriceList",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.firstPriceList.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.firstPriceList.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription' && model.subscription.key !== 'PRIVACY'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" || _this.modelSC.subscription.key === "PRIVACY")));
                            },
                        },
                    },
                    {
                        className: "col-1",
                    },
                ],
            },
            // 4. SUBSEQUENT INSERTIONS
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.subsequentInsertions.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.scanInsNext",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.scanInsNext.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.scanInsNext.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription' && model.subscription.key !== 'PRIVACY'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" || _this.modelSC.subscription.key === "PRIVACY" ||
                                            _this.modelSC.subscription.flatRate)));
                            },
                        },
                    },
                    {
                        className: "col-10",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.flatRate",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription' && model.subscription.key !== 'PRIVACY'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" || _this.modelSC.subscription.key === "PRIVACY" ||
                                            _this.modelSC.subscription.scanInsNext)));
                            },
                        },
                    },
                    {
                        className: "col-2",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalDoc",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalDoc"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalDoc"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalPdf",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalPdf"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalPdf"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                ],
            },
            // 5. SUBSEQUENT SCANS
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.subsequentScans.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.scanNext",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.scanNext.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.scanNext.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription' && model.subscription.key !== 'PRIVACY'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" || _this.modelSC.subscription.key === "PRIVACY" ||
                                            _this.modelSC.subscription.flatRateScan)));
                            },
                        },
                    },
                    {
                        className: "col-10",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.flatRateScan",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRateScan.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRateScan.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription' && model.subscription.key !== 'PRIVACY'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" || _this.modelSC.subscription.key === "PRIVACY" ||
                                            _this.modelSC.subscription.scanNext)));
                            },
                        },
                    },
                    {
                        className: "col-10",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalA4",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalA4"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalA4"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalA3",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalA3"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalA3"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalA2",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalA2"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalA2"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-1",
                    },
                    {
                        className: "col-2",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalA1",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalA1"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalA1"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalA0",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalA0"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalA0"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalOutFormat",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalOutFormat"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalOutFormat"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-1",
                    },
                ],
            },
            // 6. SUBSCRIPTION OPTIONS
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.optionsNfc.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "checkbox",
                        key: "subscription.nfcAccess",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.nfcAccess"),
                            placeholder: this.translateService.instant("companies.fields.subscription.nfcAccess"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "input",
                        key: "subscription.nfcAccessFee",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.nfcAccessFee"),
                            placeholder: this.translateService.instant("companies.fields.subscription.nfcAccessFee"),
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 10000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.nfcAccess",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.nfcAccess);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.nfcAccessBlocked",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.nfcAccessBlocked"),
                            placeholder: this.translateService.instant("companies.fields.subscription.nfcAccessBlocked"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "input",
                        key: "subscription.nfcAccessTagFee",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.nfcAccessTagFee"),
                            placeholder: this.translateService.instant("companies.fields.subscription.nfcAccessTagFee"),
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 10000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.nfcAccess",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.nfcAccess);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.nfcAccessTagBlocked",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.nfcAccessTagBlocked"),
                            placeholder: this.translateService.instant("companies.fields.subscription.nfcAccessTagBlocked"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "datepicker",
                        key: "subscription.startDateNfcAccess",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.startDateNfcAccess"),
                            placeholder: this.translateService.instant("companies.fields.subscription.startDateNfcAccess"),
                            disabled: true,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.nfcAccess",
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "datepicker",
                        key: "subscription.endDateNfcAccess",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.endDateNfcAccess"),
                            placeholder: this.translateService.instant("companies.fields.subscription.endDateNfcAccess"),
                            disabled: true,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.nfcAccess",
                        },
                    },
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.optionsSupplierEvaluation.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "checkbox",
                        key: "subscription.suppliers",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.suppliers"),
                            placeholder: this.translateService.instant("companies.fields.subscription.suppliers"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "input",
                        key: "subscription.suppliersFee",
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.fee"),
                            placeholder: this.translateService.instant("subscriptions.fields.fee"),
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 10000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.suppliers",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.suppliersBlocked",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.suppliersBlocked"),
                            placeholder: this.translateService.instant("companies.fields.subscription.suppliersBlocked"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                    {
                        className: "col-md-4",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "datepicker",
                        key: "subscription.startDateSuppliers",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.startDateSuppliers"),
                            placeholder: this.translateService.instant("companies.fields.subscription.startDateSuppliers"),
                            disabled: true,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.suppliers",
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "datepicker",
                        key: "subscription.endDateSuppliers",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.endDateSuppliers"),
                            placeholder: this.translateService.instant("companies.fields.subscription.endDateSuppliers"),
                            disabled: true,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.suppliers",
                        },
                    },
                    {
                        className: "col-md-8",
                    },
                    {
                        className: "col-md-4",
                    },
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.optionsPrivacy.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.privacy",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.privacy"),
                            placeholder: this.translateService.instant("companies.fields.subscription.privacy"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit || _this.modelSC.subscription.privacySag);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.privacySag",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.privacySag"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit || _this.modelSC.subscription.privacy);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "input",
                        key: "subscription.privacyFee",
                        defaultValue: 0,
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.fee"),
                            placeholder: this.translateService.instant("subscriptions.fields.fee"),
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 10000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.privacy || model.subscription.privacySag",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.privacyBlocked",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.privacyBlocked"),
                            placeholder: this.translateService.instant("companies.fields.subscription.privacyBlocked"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                    {
                        className: "col-md-4",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "datepicker",
                        key: "subscription.startDatePrivacy",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.startDatePrivacy"),
                            placeholder: this.translateService.instant("companies.fields.subscription.startDatePrivacy"),
                            disabled: true,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.privacy || model.subscription.privacySag",
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "datepicker",
                        key: "subscription.endDatePrivacy",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.endDatePrivacy"),
                            placeholder: this.translateService.instant("companies.fields.subscription.endDatePrivacy"),
                            disabled: true,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.privacy || model.subscription.privacySag",
                        },
                    },
                ],
            },
            // 7. PRICE LIST
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.priceList.title") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12",
                        template: "<hr />",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12",
                        template: "<hr />",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12",
                        template: "<hr />",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("companies.fields.subscription.additionalStorage.sectionTitle") +
                            "</div>",
                    },
                    {
                        className: "col-3",
                        type: "input",
                        key: "subscription.extraSpaceFee",
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.extraSpaceFee"),
                            placeholder: this.translateService.instant("subscriptions.fields.extraSpaceFee"),
                            type: "number",
                            min: 0,
                            max: 500,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription' && model.subscription.key !== 'PRIVACY'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" || _this.modelSC.subscription.key === "PRIVACY")));
                            },
                        },
                    },
                ],
            },
        ];
        this.statusFields = [
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.sag.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.sag.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.sag.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.sag.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.sag.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.sag.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.sag.date"),
                            disabled: true
                        },
                    },
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.partialMapping.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.partialMapping.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.partialMapping.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.partialMapping.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.sag &&
                                        _this.modelSP.propertyStatus.sag.checked));
                            },
                        },
                    },
                ]
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.mappingConfirmed.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.mappingConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.mappingConfirmed.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.mappingConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "checkbox",
                        key: "propertyStatus.mappingConfirmed.otherActivity",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.otherActivity"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.otherActivity"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.mappingConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-4",
                        type: "input",
                        key: "propertyStatus.mappingConfirmed.otherActivityNote",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.otherActivityNote"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.otherActivityNote"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.mappingConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                ]
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.mappingCompleted.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.mappingCompleted.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.mappingCompleted.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.date"),
                            disabled: true
                        },
                    },
                    {
                        className: "col-6",
                        type: "input",
                        key: "propertyStatus.mappingCompleted.username",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.user"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.user"),
                            disabled: true
                        },
                    },
                ]
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.insertionConfirmed.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.insertionConfirmed.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.insertionConfirmed.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.insertionConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.insertionConfirmed.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.insertionConfirmed.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.insertionConfirmed.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.insertionConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                ]
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.insertionCompleted.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.insertionCompleted.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.insertionCompleted.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.insertionCompleted.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.insertionCompleted.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.insertionCompleted.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.insertionCompleted.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.insertionCompleted.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                ]
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.startDate.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.startDate.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.startDate.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.startDate.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.ceased &&
                                        _this.modelSP.propertyStatus.ceased.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.startDate.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.startDate.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.startDate.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.startDate.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.ceased &&
                                        _this.modelSP.propertyStatus.ceased.checked));
                            },
                        },
                    },
                ]
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.ceased.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.ceased.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.ceased.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.ceased.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.ceased.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.ceased.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                ]
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.remapping.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.remapping.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.remapping.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit);
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.remapping.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.remapping.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.remapping.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSP.propertyStatus.remapping.checked);
                            },
                        },
                    },
                    {
                        className: "col-6",
                        type: "input",
                        key: "propertyStatus.remapping.user",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.remapping.user"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.remapping.user"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSP.propertyStatus.remapping.checked);
                            },
                        },
                    },
                ]
            }
        ];
    };
    /**
     * Autofill subscription values based on subscription type changes
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.updateSubscriptionCodes = function () {
        var _this = this;
        var subscriptionControl = this.formSC.controls.subscription;
        // Control fields
        var keyControl = this.formSC.controls.subscription.get("key");
        var suppliersControl = this.formSC.controls.subscription.get("suppliers");
        var startDateSuppliersControl = this.formSC.controls.subscription.get("startDateSuppliers");
        var nfcAccessControl = this.formSC.controls.subscription.get("nfcAccess");
        var startDateNfcAccessControl = this.formSC.controls.subscription.get("startDateNfcAccess");
        // Value fields
        var feeField = subscriptionControl.get("fee");
        var availableSpaceField = subscriptionControl.get("availableSpace");
        var structureField = subscriptionControl.get("structure");
        var structurePriceField = subscriptionControl.get("structurePrice");
        var firstPriceListField = subscriptionControl.get("firstPriceList");
        var scanInsNextField = subscriptionControl.get("scanInsNext");
        var flatRateField = subscriptionControl.get("flatRate");
        var scanNextField = subscriptionControl.get("scanNext");
        var flatRateScanField = subscriptionControl.get("flatRateScan");
        var startDateSuppliersField = subscriptionControl.get("startDateSuppliers");
        var endDateSuppliersField = subscriptionControl.get("endDateSuppliers");
        var suppliersFeeField = subscriptionControl.get('suppliersFee');
        var nfcAccessField = subscriptionControl.get("nfcAccess");
        var startDateNfcAccessField = subscriptionControl.get("startDateNfcAccess");
        var endDateNfcAccessField = subscriptionControl.get("endDateNfcAccess");
        var extraSpaceFeeField = subscriptionControl.get("extraSpaceFee");
        // Option fields
        var codeField;
        if (this.contractFields && Array.isArray(this.contractFields)) {
            this.contractFields.forEach(function (el) {
                if (el.fieldGroup && Array.isArray(el.fieldGroup)) {
                    el.fieldGroup.forEach(function (subEl) {
                        switch (subEl.key) {
                            case "subscription.code":
                                codeField = subEl;
                                break;
                        }
                    });
                }
            });
        }
        if (keyControl) {
            keyControl.valueChanges
                .pipe(distinctUntilChanged(), startWith(keyControl.value))
                .subscribe(function (res) {
                if (!res) {
                    return;
                }
                var index = -1;
                switch (res) {
                    case "noSubscription":
                    case "PRIVACY":
                        feeField.setValue(0);
                        availableSpaceField.setValue(0);
                        extraSpaceFeeField.setValue(0);
                        structurePriceField.setValue(0);
                        structureField.setValue(false);
                        firstPriceListField.setValue(false);
                        scanInsNextField.setValue(false);
                        flatRateField.setValue(false);
                        scanNextField.setValue(false);
                        flatRateScanField.setValue(false);
                        nfcAccessField.setValue(false);
                        break;
                    case "FULL":
                        index = _this.archediSubscriptions.findIndex(function (el) {
                            return el.key === "FULL";
                        });
                        structureField.setValue(true);
                        firstPriceListField.setValue(true);
                        scanInsNextField.setValue(false);
                        flatRateField.setValue(true);
                        scanNextField.setValue(true);
                        flatRateScanField.setValue(false);
                        break;
                    case "FULLBASIC":
                        index = _this.archediSubscriptions.findIndex(function (el) {
                            return el.key === "FULLBASIC";
                        });
                        structureField.setValue(true);
                        firstPriceListField.setValue(true);
                        scanInsNextField.setValue(true);
                        flatRateField.setValue(false);
                        scanNextField.setValue(true);
                        flatRateScanField.setValue(false);
                        break;
                    case "FREE":
                        index = _this.archediSubscriptions.findIndex(function (el) {
                            return el.key === "FREE";
                        });
                        structureField.setValue(false);
                        firstPriceListField.setValue(true);
                        scanInsNextField.setValue(false);
                        flatRateField.setValue(true);
                        scanNextField.setValue(true);
                        flatRateScanField.setValue(false);
                        break;
                    case "FREEBASIC":
                        index = _this.archediSubscriptions.findIndex(function (el) {
                            return el.key === "FREEBASIC";
                        });
                        structureField.setValue(false);
                        firstPriceListField.setValue(true);
                        scanInsNextField.setValue(true);
                        flatRateField.setValue(false);
                        scanNextField.setValue(true);
                        flatRateScanField.setValue(false);
                        break;
                }
                if (index > -1) {
                    feeField.setValue(_this.archediSubscriptions[index].fee);
                    availableSpaceField.setValue(_this.archediSubscriptions[index].availableSpace);
                    extraSpaceFeeField.setValue(_this.archediSubscriptions[index].extraSpaceFee);
                    structurePriceField.setValue(_this.archediSubscriptions[index].structurePrice);
                }
                // Backend requires a billing code whenever the matching flag is enabled.
                // Only one code is currently defined per list, so it is used directly
                // rather than filtered by plan (their "keys" arrays are inconsistently
                // maintained and do not cover every plan that sets these flags, e.g. FULLBASIC).
                var scanInsNextCode = _this.configService.availableInsCodesNext[0];
                var flatRateCode = _this.configService.availableInsCodesNextForfait[0];
                var scanNextCode = _this.configService.availableScanCodesNext[0];
                var flatRateScanCode = _this.configService.availableScanCodesNextForfait[0];
                _this.modelSC.subscription = _this.modelSC.subscription || {};
                _this.modelSC.subscription.scanInsNextCode =
                    scanInsNextField && scanInsNextField.value && scanInsNextCode
                        ? scanInsNextCode.value
                        : "INSSUCC001";
                _this.modelSC.subscription.flatRateCode =
                    flatRateField && flatRateField.value && flatRateCode
                        ? flatRateCode.value
                        : "FINSSUCC001";
                _this.modelSC.subscription.scanNextCode =
                    scanNextField && scanNextField.value && scanNextCode
                        ? scanNextCode.value
                        : "SCASUCC001";
                _this.modelSC.subscription.flatRateScanCode =
                    flatRateScanField && flatRateScanField.value && flatRateScanCode
                        ? flatRateScanCode.value
                        : "FSCASUCC001";
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
        if (suppliersControl) {
            suppliersControl.valueChanges
                .pipe(distinctUntilChanged(), startWith(suppliersControl.value))
                .subscribe(function (res) {
                if (!res) {
                    startDateSuppliersField.setValue(null);
                    endDateSuppliersField.setValue(null);
                    suppliersFeeField.setValue(null);
                }
                else {
                    if (!startDateSuppliersField.value) {
                        startDateSuppliersField.setValue(_this.masterStarDateSupplier);
                    }
                    if (!endDateSuppliersField.value) {
                        endDateSuppliersField.setValue(_this.masterEndDateSupplier);
                    }
                    if (suppliersFeeField.value == null) {
                        suppliersFeeField.setValue(_this.masterSuppliersFee);
                    }
                }
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
        if (startDateSuppliersControl) {
            startDateSuppliersControl.valueChanges
                .pipe(distinctUntilChanged(), startWith(startDateSuppliersControl.value))
                .subscribe(function (res) {
                if (!res) {
                    return;
                }
                if (res && startDateSuppliersField.dirty) {
                    // Set endDate automatically to startDate + 1 year
                    var start = new Date(res);
                    var end = start;
                    end.setDate(start.getDate() - 1);
                    end.setFullYear(end.getFullYear() + 1);
                    endDateSuppliersField.setValue(end);
                }
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
        if (startDateNfcAccessControl) {
            startDateNfcAccessControl.valueChanges
                .pipe(distinctUntilChanged(), startWith(startDateNfcAccessControl.value))
                .subscribe(function (res) {
                if (!res) {
                    return;
                }
                if (res && startDateNfcAccessField.dirty) {
                    // Set endDate automatically to startDate + 1 year
                    var start = new Date(res);
                    var end = start;
                    end.setDate(start.getDate() - 1);
                    end.setFullYear(end.getFullYear() + 1);
                    endDateNfcAccessField.setValue(end);
                }
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.onFormSubmit = function (formNumber) {
        var _this = this;
        var companyChanged = false;
        // Prevent invalid form submit
        if (formNumber === 1) {
            // formChangeAdmin is a separate FormGroup (see initChangeAdminField): it
            // must be checked here as well, otherwise an unparsable handover date
            // would be dropped from the payload and the save would silently report
            // success without having stored the date the user typed.
            if (this.form.invalid || this.formChangeAdmin.invalid) {
                Object.keys(this.form.controls).forEach(function (key) {
                    _this.form.controls[key].markAsTouched();
                });
                Object.keys(this.formChangeAdmin.controls).forEach(function (key) {
                    _this.formChangeAdmin.controls[key].markAsTouched();
                });
                this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
                console.warn(this.form);
                return;
            }
            // Check platform note
            if (this.companyId !== '' &&
                this.companyId !== this.model.admin.company) {
                companyChanged = true;
            }
        }
        // Tracked at class level so it survives into onSavePropertyData's async
        // success callback (see maybeShowAdminCompanyPrivacySagDialog)
        this.adminCompanyChangedOnSubmit = companyChanged;
        if (formNumber === 2) {
            if (this.form.invalid || this.formSC.invalid) {
                Object.keys(this.form.controls).forEach(function (key) {
                    _this.form.controls[key].markAsTouched();
                });
                Object.keys(this.formSC.controls).forEach(function (key) {
                    _this.formSC.controls[key].markAsTouched();
                });
                this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
                console.warn(this.form);
                console.warn(this.formSC);
                return;
            }
        }
        this.modelSC.subscription.totalStorageSpaceUsed =
            this.previousTotalStorageSpaceUsed;
        if (companyChanged) {
            this.subscriptions.push(this.platformNotesService
                .getCompanyProperty(this.companyId, this.propertyId)
                .subscribe(function (res) {
                if (res &&
                    res.status &&
                    res.data &&
                    Array.isArray(res.data) &&
                    res.data.length > 0) {
                    var dialogRef = _this.dialog.open(CompanyPlatformNotesDialogComponent, {
                        data: {
                            notes: res.data,
                        },
                        width: "700px",
                    });
                    dialogRef
                        .beforeClosed()
                        .pipe(take(1))
                        .subscribe(function (res) {
                        if (!res) {
                            _this.subscriptions.push(_this.platformNotesService
                                .deletePropertyCompany(_this.propertyId, _this.companyId)
                                .subscribe(function (res) {
                                _this.onSavePropertyData(formNumber);
                            }, function (err) {
                                _this.helperService.handleError(err);
                            }));
                            return;
                        }
                        _this.subscriptions.push(_this.platformNotesService
                            .movePropertyCompany(_this.propertyId, _this.model.admin.company, res)
                            .subscribe(function (res) {
                            _this.onSavePropertyData(formNumber);
                        }, function (err) {
                            _this.helperService.handleError(err);
                        }));
                    });
                }
                else {
                    _this.onSavePropertyData(formNumber);
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
            }));
        }
        else {
            this.onSavePropertyData(formNumber);
        }
    };
    PropertyDetail2Component.prototype.onSavePropertyData = function (formNumber) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("properties.dialog.saveMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            // Remove blank values from model (keep falsy-but-meaningful values: 0, false, "")
            Object.keys(_this.model).forEach(function (key) {
                if (_this.model[key] === null || _this.model[key] === undefined) {
                    delete _this.model[key];
                }
            });
            Object.keys(_this.modelSC).forEach(function (key) {
                if (_this.modelSC[key] === null || _this.modelSC[key] === undefined) {
                    delete _this.modelSC[key];
                }
            });
            // "Cambio Amministratore" handover: only on the anagraphic form and only
            // for admin/operator users (the only ones who can see the field), send
            // the selected incoming company id, or an EMPTY STRING to cancel a
            // pending handover. We send "" (not null) for cancel because
            // ApiService.apiCall strips null/undefined keys from the request body,
            // so a null would never reach the backend; the backend therefore must
            // treat an empty-string incomingAdmin as "cancel handover". Set here
            // (after the blank cleanup) so clearing the field actually cancels the
            // handover. The server auto-resets incomingAdmin when admin.company
            // changes, regardless of what we send.
            // Captured before the request: when the administrator is actually
            // replaced the handover is complete, so the success handler clears the
            // "Cambio Amministratore" fields to mirror the server-side reset.
            var adminCompanyChanged = formNumber === 1 &&
                _this.loggedUserAdmin &&
                !!_this.companyId &&
                !!_this.model.admin &&
                !!_this.model.admin.company &&
                _this.companyId !== _this.model.admin.company;
            if (formNumber === 1 && _this.loggedUserAdmin) {
                var incomingAdmin = _this.modelChangeAdmin &&
                    _this.modelChangeAdmin.changeAdminCompany &&
                    _this.modelChangeAdmin.changeAdminCompany !== ""
                    ? _this.modelChangeAdmin.changeAdminCompany
                    : "";
                _this.model.incomingAdmin = incomingAdmin;
                // The handover date travels with the incoming company, but - unlike
                // incomingAdmin - it is sent ONLY when valorised: never as the
                // empty-string sentinel. An absent field leaves the stored date
                // untouched, so this form can set and overwrite the date but never
                // clears it (the backend owns the reset, e.g. on renewal). The delete
                // is required because this.model is shared across saves in the same
                // page session. No company selected means no handover, hence no date.
                delete _this.model.incomingAdminDate;
                if (incomingAdmin !== "" && _this.modelChangeAdmin.changeAdminDate) {
                    // Value must be ISO 8601: the backend rejects the italian dd/MM/yyyy
                    // with a 400. The datepicker holds a UTC moment
                    // (MAT_MOMENT_DATE_ADAPTER_OPTIONS useUtc) while an untouched field
                    // still holds the ISO string the API returned, so normalise both.
                    // moment.utc (not moment): a date-only value would otherwise be read
                    // in local time and toISOString() would move it to the previous day.
                    var handoverDate = moment.utc(_this.modelChangeAdmin.changeAdminDate);
                    if (handoverDate.isValid()) {
                        _this.model.incomingAdminDate = handoverDate.toISOString();
                    }
                }
            }
            else {
                // Any non-anagraphic save (e.g. the contract card, formNumber===2) or
                // a non-admin save must never carry the handover fields: strip any
                // incomingAdmin/incomingAdminDate left on the shared this.model by a
                // previous anagraphic save in the same page session, so they cannot
                // resurrect a handover.
                delete _this.model.incomingAdmin;
                delete _this.model.incomingAdminDate;
            }
            // Activate submit button loading status
            _this.formBtnOptions.active = true;
            var subscription;
            if (formNumber === 1) {
                subscription = _this.model.subscription
                    ? _this.model.subscription
                    : undefined;
                if (!subscription) {
                    _this.toastrService.error(_this.translateService.instant("common.errors.form_is_invalid"));
                    return;
                }
            }
            if (formNumber === 2) {
                subscription = _this.modelSC.subscription
                    ? _this.modelSC.subscription
                    : undefined;
                if (!subscription) {
                    _this.toastrService.error(_this.translateService.instant("common.errors.form_is_invalid"));
                    return;
                }
            }
            // START - Create balance details on subscriptions
            var description = "";
            var detail = [];
            if (subscription.documentUpload) {
                detail.push({
                    code: subscription.key,
                    description: description,
                    quantity: 1,
                    unitPrice: subscription.fee,
                    totalRow: subscription.fee,
                });
            }
            // structure
            if (subscription.structure &&
                subscription.key !== "FREE" &&
                subscription.key !== "FREEBASIC") {
                description = "";
                detail.push({
                    code: "",
                    description: description,
                    quantity: 1,
                    unitPrice: subscription.structurePrice,
                    totalRow: subscription.structurePrice,
                });
            }
            if (subscription.suppliers) {
                var sub = _this.configService.availableOptionsCodes.filter(function (el) {
                    return el.value === "SPL001";
                })[0];
                description = "";
                description =
                    sub && sub.description ? sub.description : "";
                description = description.replace(/\s\s+/g, " ");
                description = description.replace("#year#", moment(subscription.startDateSuppliers).year().toString());
                detail.push({
                    code: "SPL001",
                    description: description,
                    quantity: 1,
                    unitPrice: subscription.suppliersFee,
                    totalRow: subscription.suppliersFee,
                });
            }
            var newSubscription = tslib_1.__assign({}, subscription, { detail: detail });
            _this.model = tslib_1.__assign({}, _this.model, { subscription: newSubscription });
            // END - Create balance details on subscriptions
            _this.subscriptions.push(_this.propertiesService
                .update(_this.propertyId, _this.model)
                .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                .subscribe(function (res) {
                if (res) {
                    _this.toastrService.success(res.message);
                    _this.enableEdit = false;
                    if (adminCompanyChanged) {
                        _this.clearChangeAdminFields();
                    }
                    if (typeof res.data !== "undefined" && typeof res.data.subscription === "object") {
                        var newSubscription_1 = res.data.subscription;
                        var subscriptionControl = _this.formSC.controls.subscription;
                        var suppliersField = subscriptionControl.get('suppliers');
                        if (suppliersField !== null) {
                            suppliersField.setValue(newSubscription_1.suppliers);
                            _this.model.subscription.suppliers = newSubscription_1.suppliers;
                        }
                        var suppliersFeeField = subscriptionControl.get('suppliersFee');
                        if (suppliersFeeField !== null) {
                            suppliersFeeField.setValue(newSubscription_1.suppliersFee);
                            _this.model.subscription.suppliersFee = newSubscription_1.suppliersFee;
                        }
                        var startDateSuppliersField = subscriptionControl.get('startDateSuppliers');
                        if (startDateSuppliersField !== null) {
                            startDateSuppliersField.setValue(newSubscription_1.startDateSuppliers);
                            _this.model.subscription.startDateSuppliers = newSubscription_1.startDateSuppliers;
                        }
                        var endDateSuppliersField = subscriptionControl.get('endDateSuppliers');
                        if (endDateSuppliersField !== null) {
                            endDateSuppliersField.setValue(newSubscription_1.endDateSuppliers);
                            _this.model.subscription.endDateSuppliers = newSubscription_1.endDateSuppliers;
                        }
                        var suppliersBlockedField = subscriptionControl.get('suppliersBlocked');
                        if (suppliersBlockedField !== null) {
                            suppliersBlockedField.setValue(newSubscription_1.suppliersBlocked);
                            _this.model.subscription.suppliersBlocked = newSubscription_1.suppliersBlocked;
                        }
                    }
                    _this.maybeShowAdminCompanyPrivacySagDialog();
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        });
    };
    /**
     * Toggle activation in all list elements
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.onToggleSelected = function (element) {
        var _this = this;
        if (!element.checked) {
            // Prevent invalid form submit
            if (this.form.invalid) {
                Object.keys(this.form.controls).forEach(function (key) {
                    _this.form.controls[key].markAsTouched();
                });
                this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
                element.source.toggle();
                return;
            }
        }
        this.enableEdit = element.checked;
    };
    /**
     * Search companies for the "Cambio Amministratore" (change administrator)
     * field, excluding the company the property is currently assigned to.
     *
     * The current admin company is filtered out of the fetched result page on
     * the client, so it can never be selected from the dropdown. This keeps the
     * behaviour self-contained on the front-end; a definitive server-side
     * exclusion can be wired when the administrator-change backend flow is
     * implemented.
     *
     * @since 3.0.0
     */
    PropertyDetail2Component.prototype.searchCompaniesExcludingCurrentAdmin = function (start, limit, sort, sortVersus, search) {
        var _this = this;
        return this.companiesService
            .getList(start, limit, sort, sortVersus, search)
            .pipe(map(function (res) {
            var currentAdminId = _this.property.get("admin.company._id") ||
                _this.property.get("admin.company");
            if (currentAdminId &&
                res &&
                res.status &&
                res.data &&
                Array.isArray(res.data.items)) {
                res.data.items = res.data.items.filter(function (item) { return item && item._id !== currentAdminId; });
            }
            return res;
        }));
    };
    /**
     * Build the "Cambio Amministratore" (incoming administrator / handover) field.
     *
     * The field lives in its own Formly form (formChangeAdmin / modelChangeAdmin),
     * decoupled from the anagraphic form; its value is copied into the property
     * payload as the `incomingAdmin` company id only at submit time.
     *
     * `incomingAdmin` is returned by the API as a raw ObjectId string (not
     * populated). When a handover is already pending we pre-fill the field value
     * up-front (so an untouched save never cancels it) and resolve the company to
     * display its name.
     *
     * @since 3.0.0
     */
    PropertyDetail2Component.prototype.initChangeAdminField = function () {
        var _this = this;
        var minTermLength = 1;
        var buildField = function (initialValues) {
            _this.changeAdminFields = [
                {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                        {
                            className: "col-12 col-md-6",
                            type: "autocomplete",
                            key: "changeAdminCompany",
                            templateOptions: {
                                customLabel: _this.translateService.instant("properties.fields.changeAdmin"),
                                placeholder: _this.translateService.instant("properties.fields.changeAdmin"),
                                required: false,
                                bindLabel: "name",
                                bindValue: "_id",
                                multiple: false,
                                search$: _this.searchCompaniesExcludingCurrentAdmin.bind(_this),
                                initialValues: initialValues,
                                hideSelected: true,
                                disabled: _this.loggedUserMaster,
                                minTermLength: minTermLength,
                                typeToSearchText: _this.translateService.instant("common.words.typeToSearch", { minTermLength: minTermLength }),
                                clearAllText: _this.translateService.instant("common.words.clearAll"),
                                notFoundText: _this.translateService.instant("common.words.notFound"),
                                loadingText: _this.translateService.instant("common.words.loading"),
                                callback: function (data) {
                                    _this.onChangeAdminCompanySelected(data);
                                },
                            },
                        },
                        {
                            className: "col-12 col-md-6",
                            type: "datepicker",
                            key: "changeAdminDate",
                            templateOptions: {
                                label: _this.translateService.instant("properties.fields.changeAdminDate"),
                                placeholder: _this.translateService.instant("properties.fields.changeAdminDate"),
                                required: false,
                                disabled: _this.loggedUserMaster,
                            },
                        },
                    ],
                },
            ];
        };
        var incomingAdminId = this.propertyData && this.propertyData.incomingAdmin
            ? this.propertyData.incomingAdmin
            : undefined;
        this.currentIncomingAdminId = incomingAdminId;
        if (!incomingAdminId) {
            buildField([]);
            return;
        }
        // Pre-fill the values up-front so an untouched save re-sends the same id and
        // date, and never accidentally cancels the pending handover, even if the
        // lookup fails. The date arrives as an ISO 8601 string and is kept as such:
        // mat-datepicker displays it through MomentDateAdapter.deserialize(), which
        // parses it as UTC (MAT_MOMENT_DATE_ADAPTER_OPTIONS useUtc).
        var storedHandoverDate = this.propertyData && this.propertyData.incomingAdminDate
            ? this.propertyData.incomingAdminDate
            : undefined;
        // A stored date the adapter cannot parse would become an invalid moment,
        // matDatepickerParse would flag the field and the submit guard would then
        // block every anagraphic save on this property: drop it instead.
        var storedHandoverDateIsValid = storedHandoverDate &&
            moment.utc(storedHandoverDate, moment.ISO_8601).isValid();
        this.modelChangeAdmin = {
            changeAdminCompany: incomingAdminId,
            changeAdminDate: storedHandoverDateIsValid ? storedHandoverDate : undefined,
        };
        this.subscriptions.push(this.companiesService.get(incomingAdminId).subscribe(function (res) {
            buildField(res && res.status && res.data ? [res.data] : []);
        }, function () {
            buildField([]);
        }));
    };
    /**
     * Keep the handover date coupled to the incoming administrator.
     *
     * The date only means something together with an incoming company: the submit
     * never sends `incomingAdminDate` without one, and a reload does not display
     * it either (initChangeAdminField bails out when there is no handover).
     * Clearing the company therefore clears the date on screen as well, so the
     * form does not keep showing a date that is no longer part of any handover
     * (the save handler does not rebuild this field).
     *
     * @param company the selected incoming company, undefined when cleared
     *
     * @since 3.0.0
     */
    PropertyDetail2Component.prototype.onChangeAdminCompanySelected = function (company) {
        if (company) {
            return;
        }
        var dateControl = this.formChangeAdmin.get("changeAdminDate");
        if (dateControl !== null) {
            dateControl.setValue(null);
        }
        if (this.modelChangeAdmin) {
            this.modelChangeAdmin.changeAdminDate = undefined;
        }
    };
    /**
     * Empty the "Cambio Amministratore" fields once the handover is complete.
     *
     * Called after a successful save that replaced admin.company: the backend
     * resets incomingAdmin/incomingAdminDate in that case, so the form must not
     * keep showing (and re-sending on the next save) the old handover values.
     *
     * @since 3.0.0
     */
    PropertyDetail2Component.prototype.clearChangeAdminFields = function () {
        var companyControl = this.formChangeAdmin.get("changeAdminCompany");
        if (companyControl !== null) {
            companyControl.setValue(null);
        }
        var dateControl = this.formChangeAdmin.get("changeAdminDate");
        if (dateControl !== null) {
            dateControl.setValue(null);
        }
        this.modelChangeAdmin = {
            changeAdminCompany: undefined,
            changeAdminDate: undefined,
        };
    };
    // Copy email from admin company
    PropertyDetail2Component.prototype.onAdminCompanySelected = function (company) {
        var _this = this;
        if (!this.model.admin || !company) {
            return;
        }
        if (company) {
            // Kept for maybeShowAdminCompanyPrivacySagDialog, called after save: at
            // that point this.model.admin.company only holds the company id, not
            // its subscription, so the full object selected here is needed.
            this.selectedAdminCompanyForPrivacyCheck = company;
            if (company.email && company.email !== "") {
                var notifyMail1Control = this.form.controls.notifyMail1;
                notifyMail1Control.setValue(company.email);
            }
            if (company.subscription) {
                Object.keys(company.subscription).forEach(function (key) {
                    if (key === 'startDateSuppliers') {
                        _this.masterStarDateSupplier = company.subscription[key];
                    }
                    if (key === 'endDateSuppliers') {
                        _this.masterEndDateSupplier = company.subscription[key];
                    }
                    if (key === 'suppliersFee') {
                        _this.masterSuppliersFee = company.subscription[key];
                    }
                });
            }
        }
    };
    /**
     * When the property's admin company has just been changed (form 1 saved
     * successfully with a different admin.company) to one with an active
     * "Privacy SAG" subscription, open a dialog prompting the user to
     * (re)generate the mandatory privacy documents for this property.
     *
     * Only triggers on an actual change, never on a same-company re-save (see
     * adminCompanyChangedOnSubmit, set from onFormSubmit's companyChanged).
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.maybeShowAdminCompanyPrivacySagDialog = function () {
        var _this = this;
        var companyChanged = this.adminCompanyChangedOnSubmit;
        var company = this.selectedAdminCompanyForPrivacyCheck;
        // Reset immediately so a later, unrelated save of this form doesn't
        // re-trigger the dialog with a stale selection.
        this.adminCompanyChangedOnSubmit = false;
        if (!companyChanged || !company || !company.subscription || !company.subscription.privacySag) {
            return;
        }
        var companyId = company._id;
        if (!companyId) {
            return;
        }
        this.subscriptions.push(forkJoin([
            this.archiveV3Live
                ? this.getPrivacySagArchiveTree()
                : this.propertyData && this.propertyData.documentArchive
                    ? this.documentArchivesService.get(this.propertyData.documentArchive)
                    : of(null),
            this.propertyData && this.propertyData.structure
                ? this.condoStructuresService.getCondoStructuresCaretakers(this.propertyData.structure)
                : of(null),
        ]).subscribe(function (_a) {
            var _b = tslib_1.__read(_a, 2), archiveRes = _b[0], caretakersRes = _b[1];
            var hasLeaseContracts = _this.archiveV3Live
                ? treeHasLeaseContract(archiveRes && archiveRes.data ? archiveRes.data : undefined)
                : _this.hasLeaseContractDocuments(archiveRes && archiveRes.data ? archiveRes.data : undefined);
            var hasCaretaker = !!(caretakersRes &&
                caretakersRes.data &&
                Array.isArray(caretakersRes.data.dipendenti) &&
                caretakersRes.data.dipendenti.length > 0);
            _this.dialog.open(AdminCompanyPrivacySagDialogComponent, {
                data: {
                    propertyId: _this.propertyId,
                    companyId: companyId,
                    hasLeaseContracts: hasLeaseContracts,
                    hasCaretaker: hasCaretaker,
                },
                width: "560px",
                disableClose: true,
            });
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * The 3.0.0 archive tree of this property, for maybeShowAdminCompanyPrivacySagDialog.
     *
     * A 404 (property without an archive, or out of the caller's perimeter) is treated as the
     * legacy missing `documentArchive`: null, so the dialog still opens with no lease contracts.
     * Any other error is rethrown to the subscriber, as for the legacy read.
     *
     * @since 3.0.0
     */
    PropertyDetail2Component.prototype.getPrivacySagArchiveTree = function () {
        if (!this.propertyId) {
            return of(null);
        }
        return this.documentArchiveDocsService.getTreeByProperty(this.propertyId).pipe(catchError(function (err) { return err && err.status === 404 ? of(null) : throwError(err); }));
    };
    /**
     * The "locazioneContrdiLocazione" (lease contracts) document archive
     * category groups documents by type under `documents`: it is considered
     * non-empty if any of those groups has at least one non-deleted entry
     * (same criterion used for document presence in view-property.page.ts).
     *
     * @since 1.0.0
     */
    PropertyDetail2Component.prototype.hasLeaseContractDocuments = function (documentArchive) {
        var section = documentArchive && documentArchive.locazioneContrdiLocazione;
        if (!section || !section.documents) {
            return false;
        }
        return Object.keys(section.documents).some(function (key) {
            var docs = section.documents[key];
            return Array.isArray(docs) && docs.some(function (item) { return item && !item.deleted; });
        });
    };
    return PropertyDetail2Component;
}());
export { PropertyDetail2Component };
